import { createContext } from "react";

const ChartWorkspaceDrawingContext = createContext({
  paneId: null,
  updateDrawing: null,
});

export default ChartWorkspaceDrawingContext;
